import {Component} from "@angular/core";
import {BaseEditWorkDatesComponent} from "../base-edit-work-dates/base-edit-work-dates.component";
import {BookCompletionLabels} from "src/app/enums/Book";
import {isBook} from "src/app/utils/works-type-guards.util";
import {BookCompletion} from "src/app/modules/auth/models/User";
import {EditWorkCompletionDatesComponent} from "../edit-work-completion-dates/edit-work-completion-dates.component";
import {TranslateModule} from "@ngx-translate/core";
import {WorkTimeHistoryComponent} from "../../../works/components/work-time-history/work-time-history.component";

@Component({
  selector: "app-edit-book-dates",
  templateUrl: "./edit-book-dates.component.html",
  imports: [
    EditWorkCompletionDatesComponent,
    TranslateModule,
    WorkTimeHistoryComponent,
  ],
})
export class EditBookDatesComponent extends BaseEditWorkDatesComponent {
  public isBook = isBook;
  public completionLabels = BookCompletionLabels;

  public getCompletionLabels(completion: string) {
    return BookCompletionLabels[
      completion as keyof typeof BookCompletionLabels
    ];
  }

  trackByFn(_index: number, item: BookCompletion) {
    return item.completion;
  }
}
